/** The dashboard's two button looks: the row's one primary act, and the rest. */
const BUTTON = "rounded-md px-3 py-2 text-sm font-medium disabled:cursor-not-allowed disabled:opacity-50";
export const PRIMARY_BUTTON = `${BUTTON} bg-blue-600 text-white hover:bg-blue-700`;
export const SECONDARY_BUTTON = `${BUTTON} border border-gray-300 bg-white text-gray-700 hover:bg-gray-50`;
